<template>
  <div class="LoginView container flex flex-col lg-justify-center">
    <div class="mb-24 grid col-1 lg-col-2 pb-40">
      <div class="LoginView__left lg-pr-112">
        <template v-if="productionTip">
          <div>
            <img
              v-if="productionTip.Image"
              class="w-full hide md-d-block"
              :src="`${productionTip.Image.data.attributes.url}`"
              alt="Production tip image"
            />
            <div class="hide lg-d-block">
              <h2 class="font-family-display font-weight-bold mb-24">
                {{ productionTip.Title }}
              </h2>
              <p>{{ productionTip.Text }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="LoginView__right pt-40 md-pt-0">
        <LoginForm />
      </div>
    </div>
  </div>
</template>

<script setup>
import LoginForm from '@/components/forms/LoginForm.vue'
import { storeToRefs } from 'pinia'
import { useCmsStore } from '@/stores/cmsStore'

const cmsStore = useCmsStore()
const { productionTip } = storeToRefs(cmsStore)
</script>

<style lang="scss" scoped>
.LoginView {
  margin-top: 100px;
  margin-bottom: 0;
}
</style>
